import { render, staticRenderFns } from "./InvoicesTemplateSelectorComponent.vue?vue&type=template&id=73a25294&scoped=true&lang=pug"
import script from "./InvoicesTemplateSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./InvoicesTemplateSelectorComponent.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesTemplateSelectorComponent.vue?vue&type=style&index=0&id=73a25294&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a25294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a25294')) {
      api.createRecord('73a25294', component.options)
    } else {
      api.reload('73a25294', component.options)
    }
    module.hot.accept("./InvoicesTemplateSelectorComponent.vue?vue&type=template&id=73a25294&scoped=true&lang=pug", function () {
      api.rerender('73a25294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/PrintOrSaveInvoicesDialog/InvoicesTemplateSelectorComponent.vue"
export default component.exports